import { brandingVariables } from 'smartsuite-ui/lib/constants/brandingVariables';
import { createTheme } from '@material-ui/core/styles';

const brockMuiTheme = createTheme({
    typography: {
        fontFamily: 'Open Sans, Arial, Helvetica, sans-serif',
    },
    palette: {
        action: {
            disabled: brandingVariables.accent1,
            hover: brandingVariables.backing,
        },
        text: {
            primary: brandingVariables.accent4,
            disabled: brandingVariables.accent1,
        },
    },
});

export default brockMuiTheme;
